module.exports = __webpack_public_path__ + "img/Turkmenistan.26863b57.svg";